import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { useDispatch, useSelector, batch } from "react-redux";
import {
  fetchSummaryVoucherInfo,
  updateVoucherInfo,
} from "redux/slices/sales/salesSlice";

import { getServiceTypeName } from "utils/define";
import { getCommaNumber, getPercent } from "utils/format";

import Section from "components/ui/Section";

/**
 * [이용권 종류별 매출 개요]
 */

export const VoucherInfo = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    searchPartner,
    searchBranch,
    searchDate,
    searchPeriodType,
    summaryVoucherInfo,
  } = useSelector((state) => state.sales);
  const partnerInfo = useSelector((state) => state.partner);

  useEffect(() => {
    const isUpdate =
      searchPartner != summaryVoucherInfo.searchPartner ||
      searchBranch != summaryVoucherInfo.searchBranch ||
      searchDate != summaryVoucherInfo.searchDate ||
      searchPeriodType != summaryVoucherInfo.searchPeriodType;
    if (isUpdate) {
      eventHandler.update();
    }
  }, [searchPartner, searchBranch, searchDate, searchPeriodType]);

  const eventHandler = {
    update: () => {
      dispatch(
        updateVoucherInfo(
          {
            searchPartner: searchPartner,
            searchBranch: searchBranch,
            searchDate: searchDate,
            searchPeriodType: searchPeriodType,
          },
          fetchSummaryVoucherInfo,
          "summaryVoucherInfo"
        )
      );
    },
    detail: () => {
      const isBranch =
        partnerInfo.branchUseYn == "Y" && partnerInfo.seqPartnerBranch == 0;
      if (isBranch) {
        navigate("/sales/branch/voucher");
      } else {
        navigate("/sales/voucher");
      }
    },
  };

  const render = () => {
    const getSummaryList = () => {
      const serviceTypeList = [
        "appointment",
        "class",
        "place",
        "option",
        "package",
      ];
      const data = (summaryVoucherInfo.data || {}).voucherInfo || {};

      const li = serviceTypeList.map((item) => {
        const amount = data[item + "SalesAmount"] || data[item + "SaleAmount"];
        const percent =
          data[item + "SalesPercent"] || data[item + "SalePercent"] || 0;
        // const percent = getPercent(amount, data.totalSalesAmount, 2);
        return (
          <li key={item}>
            <div>
              <span className={"spot bg-" + item} />
              <span>{getServiceTypeName(item)}</span>
              <span className={"percent " + item}>{percent}%</span>
            </div>
            <div>{getCommaNumber(amount)}원</div>
          </li>
        );
      });
      return <ul className="color">{li}</ul>;
    };

    return (
      <Section
        title="이용권 종류별 매출"
        onClick={eventHandler.detail}
        onRefresh={eventHandler.update}
        isLoading={summaryVoucherInfo.isLoading}
        isError={summaryVoucherInfo.isError}
      >
        <Wrapper>{getSummaryList()}</Wrapper>
      </Section>
    );
  };

  return render();
};

const Wrapper = styled.div`
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  li:first-child {
    margin-top: 15px;
  }
  li + li {
    margin-top: 12px;
  }
  li > div:first-child {
    display: flex;
    align-items: center;
  }
  li .percent {
    font-size: var(--14px);
  }
  li .percent:before {
    content: "·";
    margin: 0 0.35em;
  }
  li .spot {
    margin-right: 5px;
    width: 8px;
    height: 8px;
    border-radius: 100%;
  }

  .bg-appointment {
    background-color: var(--appointment);
  }
  .bg-class {
    background-color: var(--class);
  }
  .bg-place {
    background-color: var(--place);
  }
  .bg-option {
    background-color: var(--option);
  }
  .bg-package {
    background-color: var(--package);
  }
`;

export default VoucherInfo;
